<template>
  <button
    :aria-label="label"
    class="grid h-10 w-10 place-items-center rounded-[var(--radius-md)] border border-border text-lg transition-colors"
    :class="active ? 'bg-primary text-primary-foreground border-transparent' : 'bg-card text-foreground hover:bg-secondary'"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
defineProps<{ label: string; active?: boolean }>()
defineEmits<{ click: [] }>()
</script>
